module.exports = __webpack_public_path__ + "static/enchanted-pond2-39a0d02af004499bb19b492960eff950.jpg";